import styled from "styled-components"
import { Container } from "react-bootstrap"
import SharedTitle from "~/components/UI/SharedTitle"
import { useTranslation } from "~/i18n"
import breakpoints from "~/components/UI/breakpoints"
import Icon from "~/components/UI/Icon"
import { getContent1, getContent2, getContent3 } from './contents'
import { useMemo } from "react"
import Text from "~/components/UI/Text"

const MyContainer = styled(Container)`
`

const Title = styled(SharedTitle)`
  ${breakpoints.md} {
    font-size: 36px;
  }
`

const Table = styled.table`
  border: 1px solid rgba(26, 26, 26, 0.1);
  th, td {
    border: 1px solid rgba(26, 26, 26, 0.1);
    padding: 10px 20px;
    width: 50%;
  }
  .howitwork-body-title {
    p {
      text-transform: uppercase;
    }
  }
  .howitwork-body-col2 {
    background-color: #0084ff;
  }
  .howitwork-body-col1 {
    background-color: #f9fafc;
  }
`

const Content: React.FC<{ contentIndex: number }> = ({ contentIndex }) => {
  const [t] = useTranslation()

  const _content1 = useMemo(() => getContent1(t), [])
  const _content2 = useMemo(() => getContent2(t), [])
  const _content3 = useMemo(() => getContent3(t), [])
  const renderedContent = useMemo(() => {

    let _content = _content1
    switch (contentIndex) {
      case 2: _content = _content2; break;
      case 3: _content = _content3; break;
    }

    return _content.map(content => {
      // title
      if (Object.keys(content).length === 1) {
        return (
          <tr>
            <td className='howitwork-body-title' colSpan={2}>
              <Text color='#9dadc3' centered>
                {content.col1}
              </Text>
            </td>
          </tr>
        )
      } else {
        // content
        return (
          <tr>
            <td className='howitwork-body-col1'>
              <Text>
                {content.col1}
              </Text>
            </td>
            <td className='howitwork-body-col2'>
              <Text color='#fff'>
                {content.col2}
              </Text>
            </td>
          </tr>
        )
      }
    })
  }, [contentIndex])

  const title = useMemo(() => {
    switch (contentIndex) {
      case 1: return t`Vốn đầu tư - Thanh toán`;
      case 2: return t`Lợi nhuận - Tính an toàn`;
      default: return t`Hợp đồng - Pháp lý`;
    }
  }, [contentIndex])

  return (
    <MyContainer>
      <Title centered padding='0 0 40px 0'>
        {title}
      </Title>
      <Table>
        <thead>
          <tr>
            <th>
              <Text size={24} centered bold>
                {t`Truyền Thống`}
              </Text>
            </th>
            <th>
              <Text size={24} centered bold>
                <span style={{ marginRight: 16 }}>{t`Infina`}</span>
                <Icon name='verified' />
              </Text>
            </th>
          </tr>
        </thead>
        <tbody>
          {renderedContent}
        </tbody>
      </Table>
    </MyContainer>
  )
}

export default Content
